import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import * as fromGraphQl from './graphql';
// migrated 1:1 from @nexato/nx-core-module (#682)
import { NXDataSourcePrime } from '../../../services/dataSource/NXDataSourcePrime';
import { IssueType } from '../../../entities/issue/issue-type';
import { IssueTypesComponent } from './issue-types.component';

export class IssueTypesDataSource extends NXDataSourcePrime<Event> {
  constructor(apollo: Apollo,
    @Inject('env') environment: any,
    private issueTypesComponent: IssueTypesComponent
    ) {
    super(apollo, fromGraphQl.ISSUETYPES_QUERY, environment);
  }
  public selectedIssueType: IssueType;
  
  handleSubscriptionResult(data: fromGraphQl.IssueTypesQueryResponse): void {
    super.setSubject(
      data?.issueTypes?.content ? IssueType.createIssueTypes(data?.issueTypes?.content) : [],
      data?.issueTypes?.totalElements ? data?.issueTypes.totalElements : 0
    );
    if (data?.issueTypes?.totalElements > 0) {
      if(!this.selectedIssueType) {
        this.selectedIssueType = new IssueType(data?.issueTypes?.content[0]);
        this.issueTypesComponent.setMenuItems();
      }
    }
    else {
      this.selectedIssueType = undefined;
    }
    this.querySubscription?.unsubscribe();
  }

  loadIssueTypes(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
